import styled from 'styled-components';

const Heading = styled.h2`
  color: #4A4A4A;
  margin: 0 0 1em;
`;

const HeadColumn = styled.div`
  justify-self: ${props => props.end ? 'end': 'stretch'};
`;

const FlexRow = styled.div`
	display: flex;
	align-items: center;
	margin: 0 0 24px;

	h2 {
		margin: 0 24px 0 0;
	}
`;

const Head = styled.div`
	display: flex;
	justify-content: space-between;
`;

const Body = styled.div`
	display: flex;
	flex-direction: ${props => props.type === 'tile' ? 'row' : 'column'};
	flex-wrap: wrap;
	margin: 40px 0 0 0;
`;

const Container = styled.div`
  margin: 0 40px;
  border-top: 2px solid #E6E6E6;
  padding: 40px 0;
	display: flex;
  flex-direction: column;
`;

const BrochureLegend = styled.span`
	display: inline-block;
	border-radius: 4px;
	width: 80px;
	height: 24px;
	background-color: white;
	color: #4A90E2;
	text-align: center;
	line-height: 20px;
	border-top: 3px solid ${props => props.master ? '#4A90E2': '#FFFFFF'};
	font-size: 12px;
	user-select: none;
	cursor: normal;
	text-transform: uppercase;
	letter-spacing: 1px;
	margin-left: 16px;
	opacity: 0.3;
	transition: opacity 0.3s ease-out;

	&:hover {
		opacity: 1;
	}
`;

const ListTypeContainer = styled.div`
  button:nth-child(1) {
		margin-right: 16px;
	}
`;

export {
	Heading,
	HeadColumn,
	FlexRow,
	Head,
	Body,
	Container,
	BrochureLegend,
	ListTypeContainer,
}
